export default {
  props: {
    fields: {
      type: Object,
      default: function () {
        return {}
      }
    },
    required: {
      type: Boolean,
      default: false
    },
    name: String,
    formGroupStyle: {
      type: String,
      default: 'filter-block'
    }
  },
  computed: {
    fieldName () {
      return null
    },
    tabView () {
      return 'tab1'
    }
  }
}
